var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section-card", {
    attrs: {
      "card-title": _vm.cardTitle,
      "card-icon": _vm.cardIcon,
      "is-loading": _vm.isLoading
    },
    scopedSlots: _vm._u(
      [
        {
          key: "extraHeaderContent",
          fn: function() {
            return [
              _vm.hasTopButtons
                ? [
                    _vm.hasRequestInProgress
                      ? _c(
                          "ehr-button",
                          {
                            staticClass: "float-right card-button-top",
                            attrs: {
                              "button-type-class": "btn-secondary",
                              loading: _vm.isLoading,
                              disabled: true
                            }
                          },
                          [
                            _c("span", { staticClass: "d-none d-sm-inline" }, [
                              _vm._v("Nog in behandeling ")
                            ])
                          ]
                        )
                      : !_vm.isEditing
                      ? _c(
                          "ehr-button",
                          {
                            staticClass: "float-right card-button-top",
                            attrs: {
                              "button-type-class": "btn-primary",
                              loading: _vm.isLoading,
                              icon: "pen",
                              disabled: !_vm.isEditable
                            },
                            on: {
                              click: function($event) {
                                return _vm.$emit("wijzig-dossier")
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "d-none d-sm-inline" }, [
                              _vm._v("Wijziging aanvragen")
                            ])
                          ]
                        )
                      : _vm.isEditing
                      ? _c(
                          "ehr-button",
                          {
                            staticClass: "float-right card-button-top",
                            attrs: {
                              "button-type-class": "btn-warning",
                              icon: "undo"
                            },
                            on: {
                              click: function($event) {
                                return _vm.$emit("cancel-editing")
                              }
                            }
                          },
                          [_vm._v("\n        Annuleren\n      ")]
                        )
                      : _vm._e()
                  ]
                : _vm._e()
            ]
          },
          proxy: true
        },
        {
          key: "default",
          fn: function() {
            return [_vm._t("default")]
          },
          proxy: true
        },
        {
          key: "footerContent",
          fn: function() {
            return [
              _vm.isEditing
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { disabled: !_vm.isValid },
                      on: {
                        click: function($event) {
                          return _vm.$emit("submit-changes")
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: ["fad", "save"] }
                      }),
                      _vm._v("\n      Versturen\n    ")
                    ],
                    1
                  )
                : _vm._e()
            ]
          },
          proxy: true
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }